export const CURRENT_REP_CREATE      = 'CURRENT_REP_CREATE';
export const CURRENT_REP_CREATE_DONE = 'CURRENT_REP_CREATE_DONE';

export const CURRENT_REP_UPDATE      = 'CURRENT_REP_UPDATE';
export const CURRENT_REP_UPDATE_DONE = 'CURRENT_REP_UPDATE_DONE';



// WEBPACK FOOTER //
// ./app/constants/currentRepTypes.js